var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sign-list" },
    [
      _c(
        "el-row",
        { staticClass: "row", attrs: { type: "flex", gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 9 } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary", plain: "" },
                  on: {
                    click: function($event) {
                      return _vm.showAddFile()
                    }
                  }
                },
                [_vm._v("文件保全")]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", size: "small" },
                          model: {
                            value: _vm.selectedParm,
                            callback: function($$v) {
                              _vm.selectedParm = $$v
                            },
                            expression: "selectedParm"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "文件名称", value: "contractName" }
                          }),
                          _c("el-option", {
                            attrs: { label: "文件编号", value: "applyNo" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-input", {
                        attrs: { size: "small", placeholder: "查询内容" },
                        model: {
                          value: _vm.selectedParmInfo,
                          callback: function($$v) {
                            _vm.selectedParmInfo = $$v
                          },
                          expression: "selectedParmInfo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-row",
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "unset" },
                    attrs: {
                      type: "daterange",
                      "value-format": "yyyy-MM-dd",
                      "default-time": ["00:00:00", "23:59:59"],
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      size: "small"
                    },
                    model: {
                      value: _vm.datePikerArr,
                      callback: function($$v) {
                        _vm.datePikerArr = $$v
                      },
                      expression: "datePikerArr"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "text-right", attrs: { span: 3 } },
            [
              _c(
                "el-row",
                { attrs: { type: "flex" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.findScreenSign }
                        },
                        [_vm._v("查询")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small" }, on: { click: _vm.rest } },
                        [_vm._v("重置")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-wrap" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              ref: "dataList",
              staticClass: "data-list",
              attrs: {
                data: _vm.tableList,
                "tooltip-effect": "dark",
                "header-cell-style": {
                  background: "#f9f9f9",
                  color: "#333333",
                  fontWeight: "500"
                }
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "文件编号",
                  prop: "applyNo",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: { label: "文件名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("apply-name", {
                          attrs: {
                            applyType: "applyList",
                            signInfo: {
                              status: scope.row.signStatus,
                              signNo: scope.row.signNo,
                              applyNo: scope.row.applyNo,
                              name: scope.row.contractName,
                              row: scope.row,
                              selfSign: scope.row.selfSign
                            },
                            newFont: true
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "备案号", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.vpresId
                          ? _c("span", [
                              _vm._v(
                                _vm._s(scope.row.vpresId) + "\n              "
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "保全备注",
                  prop: "remark",
                  "show-overflow-tooltip": "",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: { label: "保全时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm._f("formatDateHM")(scope.row.createTime))
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "180" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return scope.row.applySignStatus !== -1
                          ? [
                              scope.row.vpresId
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "com-normal-btn",
                                      on: {
                                        click: function($event) {
                                          return _vm.openCSDialog(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("出证")]
                                  )
                                : _vm._e(),
                              _c(
                                "certiServicepopover",
                                {
                                  attrs: {
                                    listTyp: "seniorList",
                                    param: {
                                      signNo: scope.row.signNo || "",
                                      applyNo: scope.row.applyNo || ""
                                    }
                                  }
                                },
                                [
                                  _c("span", { staticClass: "color-success" }, [
                                    _vm._v("证书")
                                  ])
                                ]
                              )
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              }),
              _c("no-data", {
                attrs: { slot: "empty", text: "暂无数据" },
                slot: "empty"
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "pageation row" },
        [
          _c(
            "el-col",
            { staticClass: "page-flex-end", attrs: { span: 24 } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.screenParme.itemPage,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.screenParme.pageSize,
                  "pager-count": 5,
                  layout: "sizes, prev, pager, next, total",
                  total: _vm.screenParme.pageTotal
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              }),
              _c("el-go", {
                attrs: {
                  "page-size": _vm.screenParme.pageSize,
                  total: _vm.screenParme.pageTotal
                },
                on: { "current-change": _vm.handleCurrentChange }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "insurance-info",
          attrs: {
            title: "文件保全",
            visible: _vm.insureDialogVisible,
            width: "60%"
          },
          on: {
            "update:visible": function($event) {
              _vm.insureDialogVisible = $event
            },
            close: _vm.getSignLists
          }
        },
        [
          _c("div", { staticClass: "info-box" }, [
            _c(
              "div",
              { staticStyle: { "overflow-y": "auto", height: "400px" } },
              [
                _c(
                  "el-row",
                  { staticClass: "row", attrs: { type: "flex" } },
                  [
                    _c(
                      "el-col",
                      {
                        staticStyle: {
                          "margin-top": "67px",
                          position: "absolute",
                          left: "0"
                        },
                        attrs: { span: 1 }
                      },
                      [
                        _vm._l(_vm.fileInfoList, function(item, i) {
                          return [
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.loading,
                                  expression: "item.loading"
                                }
                              ],
                              key: i,
                              staticStyle: {
                                width: "16px",
                                "margin-bottom": "15px"
                              },
                              attrs: { src: "/images/u2.gif" }
                            })
                          ]
                        })
                      ],
                      2
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-upload",
                          {
                            ref: "upload",
                            staticClass: "upload-demo",
                            attrs: {
                              accept: ".pdf,.doc,.docx,.jpg,.png,.bmp",
                              action: "",
                              "on-change": _vm.handleFileChange,
                              "on-remove": _vm.handleFileRemove,
                              "file-list": _vm.fileList,
                              multiple: true,
                              "auto-upload": false
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  slot: "trigger",
                                  size: "small",
                                  type: "primary"
                                },
                                slot: "trigger"
                              },
                              [_vm._v("选取文件")]
                            ),
                            _c("div", { staticClass: "upload-my-tip" }, [
                              _vm._v(
                                "\n                  已选中" +
                                  _vm._s(_vm.fileList.length) +
                                  "份文件"
                              ),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.clearAllFiles()
                                    }
                                  }
                                },
                                [_vm._v("清空文件")]
                              )
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "el-upload__tip",
                                attrs: { slot: "tip" },
                                slot: "tip"
                              },
                              [
                                _vm._v(
                                  "\n                  只能上传.pdf、.doc、.docx、.jpg、.png、.bmp格式文件，且不超过30MB\n                "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 17 } }, [
                      _c(
                        "ul",
                        { staticClass: "file-info-ls" },
                        _vm._l(_vm.fileInfoList, function(item) {
                          return _c(
                            "li",
                            { key: item.uid },
                            [
                              _c(
                                "el-row",
                                { staticClass: "row", attrs: { type: "flex" } },
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "padding-r-10",
                                      attrs: { span: 12 }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          readonly: item.loading,
                                          placeholder: "请输入文件名称"
                                        },
                                        model: {
                                          value: item.fileName,
                                          callback: function($$v) {
                                            _vm.$set(item, "fileName", $$v)
                                          },
                                          expression: "item.fileName"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "padding-l-10",
                                      attrs: { span: 12 }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          maxlength: 100,
                                          readonly: item.loading,
                                          placeholder: "保全备注"
                                        },
                                        model: {
                                          value: item.remark,
                                          callback: function($$v) {
                                            _vm.$set(item, "remark", $$v)
                                          },
                                          expression: "item.remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", [
              _c("p", [
                _vm._v("\n            已成功保全\n            "),
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(_vm.uploadedLength))
                ]),
                _vm._v(" 份文件\n          ")
              ])
            ])
          ]),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "info" },
                  on: {
                    click: function($event) {
                      return _vm.getSignLists()
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.uploadFileList()
                    }
                  }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.authDialog, title: "实名认证", width: "475px" },
          on: {
            "update:visible": function($event) {
              _vm.authDialog = $event
            }
          }
        },
        [
          _c("p", { staticClass: "authDialog" }, [
            _c("img", {
              attrs: { src: require("../../static/images/warning.png") }
            }),
            _vm._v("您还未完成实名认证，认证后才能执行该操作。\n      ")
          ]),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  staticStyle: {
                    border: "none",
                    background: "#ec1c1c",
                    color: "#ffffff"
                  },
                  attrs: { size: "small" },
                  on: { click: _vm.gotoAuth }
                },
                [_vm._v("去认证")]
              )
            ],
            1
          )
        ],
        2
      ),
      _vm.cSDialogVisible
        ? _c("certiServiceDialog", {
            attrs: {
              dialogVisible: _vm.cSDialogVisible,
              listType: "userList",
              param: _vm.cSDialogData
            },
            on: { setCSDialogData: _vm.onSetCSDialogData }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c69a3392", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c69a3392","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/signInfo/preservation.vue
// module id = X6sg
// module chunks = 50